/** The `value` of the row that clears the filter. No id can collide with it. */
export const ANY_OPTION = "__any__";

// Separates an id from the occurrence number in the value of a repeated id's later rows.
const OCCURRENCE_SEPARATOR = "\u001f";

/**
 * Returns the row value of an id's nth occurrence in a list. Rows must carry distinct values for
 * the picker to mark one of them, so a repeated id keeps the plain id on its first row and an
 * aliased one after: `toRowValue("spanish", 0)` → `"spanish"`, `toRowValue("spanish", 1)` →
 * `"spanish\u001f1"`.
 *
 * @param {String|Number} id
 * @param {Number} occurrence - How many earlier rows carry the same id.
 * @returns {String}
 */
export function toRowValue(id, occurrence) {
  return occurrence === 0 ? String(id) : `${id}${OCCURRENCE_SEPARATOR}${occurrence}`;
}

/**
 * Returns the id a row value stands for: `"spanish\u001f1"` → `"spanish"`.
 *
 * @param {String|Number} rowValue
 * @returns {String}
 */
export function idOfRowValue(rowValue) {
  return String(rowValue).split(OCCURRENCE_SEPARATOR)[0];
}
